export default __webpack_public_path__ + "static/media/IOTX-BUSD.c4e40daa.svg";